import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { RootState } from '@store/index';
import { logout } from '@features/auth/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://community-api.teexponent.com/api/v1/admin',
  timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    headers.set('Accept-Language', 'en');
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const { status } = result.error;
    if (status === 401 || status === 403) {
      api.dispatch(logout());
      window.location.href = '/login';
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User', 'Auth', 'Report', 'Category', 'ForumCategory', 'Group', 'Poll', 'Survey', 'News', 'Announcement', 'Plan', 'PlanFeature', 'Role', 'Permission', 'SponsorInvoice', 'Cms', 'Event', 'BusinessCategory', 'Fabricator', 'HelpFaq', 'SuperAdmin', 'Tag', 'SocialLink', 'ContactUs'],
  endpoints: () => ({}),
});
